import React, { Component } from "react";
import styles from "./routeTripsContent.module.scss";
import InputTime from "../../../shared/items/contols/inputTime";

class RouteTripControlPoint extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { point, onChange } = this.props;
    const valueStore = { controlPointTime: point.time };

    return (
      <div className={styles.routeTripControlPointItem}>
        <div>{point.number}. </div>
        <div> {point.title}</div>
        <div className={styles.routeTripControlPointItemTime}>
          <InputTime
            name="controlPointTime"
            onHandleChangeStore={(e, value) => {
              if (value !== undefined) {
                onChange(point.id, new Date(1970, 0, 0, value.split(":")[0], value.split(":")[1], 0));
              }
            }}
            valueStore={valueStore}
          />
        </div>
      </div>
    );
  }
}

export default React.memo(RouteTripControlPoint);
